import React from "react";
import { Field } from "redux-form";

import {
  renderField,
  RadioButtonGroupRow,
  MoreInfoGroupRow,
} from "./components";
import { validateRequired } from "./validation";
import { CheckboxField } from "cxa-form-field";

export const formHeader = (
  <div>
    <section>
      <img
        alt="aia-logo"
        src="/assets/images/hdf/aia-logo.jpg"
        className="logo"
      />
      <div className="header__details text--center">
        <h1>
          AIA SINGAPORE<br />ENROLMENT / HEALTH DECLARATION FORM
        </h1>
        <p>
          <strong>Corporate Solutions</strong>
          <br />
          3 Tampines Grande, AIA Tampines #07-00, Singapore 528799 Fax: (65)
          6538 5603 / 6538 4340
        </p>
      </div>
    </section>
    <dl className="important-note-1">
      <dt>Important Note:</dt>
      <dd>
        Pursuant to Section 25(5) of the Insurance Act and replacement thereof,
        you are to disclose in this form, fully & faithfully, all the facts
        which you know, otherwise the policy issued hereunder may be void.
      </dd>
    </dl>
  </div>
);

export const formContent = renderValue => (
  <div>
    <fieldset>
      <h3>POLICY INFORMATION</h3>
      <section className="basicinfo">
        <div style={{ width: 300 }}>
          <label htmlFor="PolicyNumber">Policy Number</label>
          <div className="field-container" id="RO_PolicyNumber">
            {renderValue({
              fieldName: "PolicyNumber",
              fieldFormat: "text",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="PolicyNumber"
              name="PolicyNumber"
            />
          </div>
        </div>
        <div className="alignright" style={{ width: 300 }}>
          <label htmlFor="EffectiveDate">Insured's Effective date</label>
          <div className="field-container" id="RO_EffectiveDate">
            {renderValue({
              fieldName: "EffectiveDate",
              fieldFormat: "date",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="EffectiveDate"
              name="EffectiveDate"
            />
          </div>
        </div>
        <div>
          <label htmlFor="CompanyName">Name of Company</label>
          <div className="field-container" id="RO_CompanyName">
            {renderValue({ fieldName: "CompanyName", fieldFormat: "text" })}
            <Field
              component={renderField}
              type="hidden"
              id="CompanyName"
              name="CompanyName"
            />
          </div>
        </div>
        <div style={{ width: 250 }}>
          <label htmlFor="TermLifeSumAssured">Term Life Sum Assured</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="TermLifeSumAssured"
              name="TermLifeSumAssured"
            />
          </div>
        </div>
        <div style={{ width: 250 }}>
          <label htmlFor="CriticalIllnessSumAssured">
            Critical Illness Sum Assured
          </label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="CriticalIllnessSumAssured"
              name="CriticalIllnessSumAssured"
            />
          </div>
        </div>
        <div style={{ width: 250 }}>
          <label htmlFor="AccidentSumAssured">Accident Sum Assured</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="AccidentSumAssured"
              name="AccidentSumAssured"
            />
          </div>
        </div>
        <div style={{ width: 200 }}>
          <label htmlFor="TermLifePlanNumber">Term Life Plan no.</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="TermLifePlanNumber"
              name="TermLifePlanNumber"
            />
          </div>
        </div>
        <div style={{ width: 200 }}>
          <label htmlFor="CriticalIllnessPlanNumber">
            Critical Illness Plan no.
          </label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="CriticalIllnessPlanNumber"
              name="CriticalIllnessPlanNumber"
            />
          </div>
        </div>
        <div style={{ width: 200 }}>
          <label htmlFor="AccidentPlanNumber">Accident Plan no.</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="AccidentPlanNumber"
              name="AccidentPlanNumber"
            />
          </div>
        </div>
        <div style={{ width: 200 }}>
          <label htmlFor="MedicalPlanNumber">Medical Plan no.</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="MedicalPlanNumber"
              name="MedicalPlanNumber"
            />
          </div>
        </div>
      </section>
    </fieldset>
    <fieldset>
      <h3>EMPLOYEE'S INFORMATION</h3>
      <section className="basicinfo">
        <div>
          <label htmlFor="EmployeeName">Name of Employee (as in NRIC)</label>
          <div className="field-container" id="RO_EmployeeName">
            {renderValue({
              fieldName: "EmployeeName",
              fieldFormat: "text",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="EmployeeName"
              name="EmployeeName"
            />
          </div>
        </div>
        <div style={{ width: 300 }}>
          <label htmlFor="Identification">NRIC/Passport No.</label>
          <div className="field-container" id="RO_Identification">
            {renderValue({
              fieldName: "Identification",
              fieldFormat: "text",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="Identification"
              name="Identification"
            />
          </div>
        </div>
        <div style={{ width: 250 }}>
          <label htmlFor="BirthDate">Date of birth</label>
          <div className="field-container" id="RO_BirthDate">
            {renderValue({ fieldName: "BirthDate", fieldFormat: "date" })}
            <Field
              component={renderField}
              type="hidden"
              id="BirthDate"
              name="BirthDate"
            />
          </div>
        </div>
        <div style={{ width: 150 }}>
          <label htmlFor="Gender">Sex</label>
          <div className="field-container" id="RO_Gender">
            {renderValue({ fieldName: "Gender", fieldFormat: "text" })}
            <Field
              component={renderField}
              type="hidden"
              id="Gender"
              name="Gender"
            />
          </div>
        </div>
        <div style={{ width: 200 }}>
          <label htmlFor="Nationality">Nationality</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="Nationality"
              name="Nationality"
              validate={validateRequired}
            />
          </div>
        </div>
        <div style={{ width: 300 }}>
          <label htmlFor="JobTitle">Occupation</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="JobTitle"
              name="JobTitle"
              validate={validateRequired}
            />
          </div>
        </div>
        <div style={{ width: 150 }}>
          <label htmlFor="MaritalStatus">Marital Status</label>
          <div className="field-container" id="RO_MaritalStatus">
            {renderValue({
              fieldName: "MaritalStatus",
              fieldFormat: "text",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="MaritalStatus"
              name="MaritalStatus"
            />
          </div>
        </div>
        <div style={{ width: 100 }}>
          <label htmlFor="Height">Height</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="Height"
              name="Height"
              style={{ width: "70%" }}
              validate={validateRequired}
            />
          </div>
        </div>
        <div style={{ width: 100 }}>
          <label htmlFor="Weight">Weight</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="Weight"
              name="Weight"
              style={{ width: "70%" }}
              validate={validateRequired}
            />
          </div>
        </div>
        <div style={{ width: 200 }}>
          <label htmlFor>Monthly Salary</label>
          <div className="field-container" />
        </div>
        <div className="clearboth" />
        <div style={{ width: 250 }}>
          <label htmlFor="ContactNumber">Telephone No</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="ContactNumber"
              name="ContactNumber"
              style={{ width: "95%" }}
              placeholder={6}
            />
          </div>
        </div>
        <div style={{ width: 420 }}>
          <label htmlFor="EmailAddress">Email Address</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="EmailAddress"
              name="EmailAddress"
            />
          </div>
        </div>
        <div style={{ width: 250 }}>
          <label htmlFor="EffectiveDate">Employment Date</label>
          <div className="field-container" id="RO_EffectiveDate">
            {renderValue({
              fieldName: "EffectiveDate",
              fieldFormat: "date",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="EffectiveDate"
              name="EffectiveDate"
            />
          </div>
        </div>
        <div className="clearboth" />
        <div style={{ width: 200 }}>
          <label htmlFor="BankName">Bank</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="BankName"
              name="BankName"
            />
          </div>
        </div>
        <div style={{ width: 200 }}>
          <label htmlFor="BankBranch">Branch</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="BankBranch"
              name="BankBranch"
            />
          </div>
        </div>
        <div style={{ width: 520 }}>
          <label htmlFor="BankAccountNumber">
            Account No (For Giro Purpose)
          </label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="BankAccountNumber"
              name="BankAccountNumber"
            />
          </div>
        </div>
        <div>
          <label htmlFor="ResidentialAddress">Residential Address</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="ResidentialAddress"
              name="ResidentialAddress"
            />
          </div>
        </div>
        <div style={{ width: 200 }}>
          <label htmlFor="ResidentialPostalCode">Postal Code</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="ResidentialPostalCode"
              name="ResidentialPostalCode"
            />
          </div>
        </div>
      </section>
    </fieldset>
    <fieldset>
      <h3>
        DEPENDENT'S INFORMATION (to complete only if spouse/children are
        covered)
      </h3>
      <section className="basicinfo">
        <div>
          <label htmlFor="SpouseName">
            Name of spouse (Full as shown in NRIC)
          </label>
          <div className="field-container" id="RO_SpouseName">
            {renderValue({ fieldName: "SpouseName", fieldFormat: "text" })}
            <Field
              component={renderField}
              type="hidden"
              id="SpouseName"
              name="SpouseName"
            />
          </div>
        </div>
        <div style={{ width: 420 }}>
          <label htmlFor="SpouseIdentification">NRIC/Passport No.</label>
          <div className="field-container" id="RO_SpouseIdentification">
            {renderValue({
              fieldName: "SpouseIdentification",
              fieldFormat: "text",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="SpouseIdentification"
              name="SpouseIdentification"
            />
          </div>
        </div>
        <div style={{ width: 250 }}>
          <label htmlFor="SpouseBirthDate">Date of birth</label>
          <div className="field-container" id="RO_SpouseBirthDate">
            {renderValue({
              fieldName: "SpouseBirthDate",
              fieldFormat: "date",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="SpouseBirthDate"
              name="SpouseBirthDate"
            />
          </div>
        </div>
        <div style={{ width: 250 }}>
          <label htmlFor="MarriageDate">Date of Marriage</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="MarriageDate"
              name="MarriageDate"
            />
          </div>
        </div>
        <div style={{ width: 420 }}>
          <label htmlFor="SpouseJobTitle">Occupation</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="SpouseJobTitle"
              name="SpouseJobTitle"
            />
          </div>
        </div>
        <div style={{ width: 150 }}>
          <label htmlFor="SpouseHeight">Height(m)</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="SpouseHeight"
              name="SpouseHeight"
            />
          </div>
        </div>
        <div style={{ width: 150 }}>
          <label htmlFor="SpouseWeight">Weight(kg)</label>
          <div className="field-container">
            <Field
              component={renderField}
              type="text"
              id="SpouseWeight"
              name="SpouseWeight"
            />
          </div>
        </div>
        <div style={{ width: 100 }}>
          <label htmlFor="SpouseGender">Sex</label>
          <div className="field-container" id="RO_SpouseGender">
            {renderValue({
              fieldName: "SpouseGender",
              fieldFormat: "text",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="SpouseGender"
              name="SpouseGender"
            />
          </div>
        </div>
        <div>
          <label htmlFor="FirstChildName">
            Name of 1st child (Full as shown in NRIC/BC)
          </label>
          <div className="field-container" id="RO_FirstChildName">
            {renderValue({
              fieldName: "FirstChildName",
              fieldFormat: "text",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="FirstChildName"
              name="FirstChildName"
            />
          </div>
        </div>
        <div style={{ width: 420 }}>
          <label htmlFor="FirstChildIdentification">
            NRIC/Passport No./BC No.
          </label>
          <div className="field-container" id="RO_FirstChildIdentification">
            {renderValue({
              fieldName: "FirstChildIdentification",
              fieldFormat: "text",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="FirstChildIdentification"
              name="FirstChildIdentification"
            />
          </div>
        </div>
        <div style={{ width: 250 }}>
          <label htmlFor="FirstChildBirthDate">Date of birth</label>
          <div className="field-container" id="RO_FirstChildBirthDate">
            {renderValue({
              fieldName: "FirstChildBirthDate",
              fieldFormat: "date",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="FirstChildBirthDate"
              name="FirstChildBirthDate"
            />
          </div>
        </div>
        <div style={{ width: 100 }}>
          <label htmlFor="FirstChildGender">Sex</label>
          <div className="field-container" id="RO_FirstChildGender">
            {renderValue({
              fieldName: "FirstChildGender",
              fieldFormat: "text",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="FirstChildGender"
              name="FirstChildGender"
            />
          </div>
        </div>
        <div>
          <label htmlFor="SecondChildName">
            Name of 2nd child (Full as shown in NRIC/BC)
          </label>
          <div className="field-container" id="RO_SecondChildName">
            {renderValue({
              fieldName: "SecondChildName",
              fieldFormat: "text",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="SecondChildName"
              name="SecondChildName"
            />
          </div>
        </div>
        <div style={{ width: 420 }}>
          <label htmlFor="SecondChildIdentification">
            NRIC/Passport No./BC No.
          </label>
          <div className="field-container" id="RO_SecondChildIdentification">
            {renderValue({
              fieldName: "SecondChildIdentification",
              fieldFormat: "text",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="SecondChildIdentification"
              name="SecondChildIdentification"
            />
          </div>
        </div>
        <div style={{ width: 250 }}>
          <label htmlFor="SecondChildBirthDate">Date of birth</label>
          <div className="field-container" id="RO_SecondChildBirthDate">
            {renderValue({
              fieldName: "SecondChildBirthDate",
              fieldFormat: "date",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="SecondChildBirthDate"
              name="SecondChildBirthDate"
            />
          </div>
        </div>
        <div style={{ width: 100 }}>
          <label htmlFor="SecondChildGender">Sex</label>
          <div className="field-container" id="RO_SecondChildGender">
            {renderValue({
              fieldName: "SecondChildGender",
              fieldFormat: "text",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="SecondChildGender"
              name="SecondChildGender"
            />
          </div>
        </div>
        <div>
          <label htmlFor="ThirdChildName">
            Name of 3rd child (Full as shown in NRIC/BC)
          </label>
          <div className="field-container" id="RO_ThirdChildName">
            {renderValue({
              fieldName: "ThirdChildName",
              fieldFormat: "text",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="ThirdChildName"
              name="ThirdChildName"
            />
          </div>
        </div>
        <div style={{ width: 420 }}>
          <label htmlFor="ThirdChildIdentification">
            NRIC/Passport No./BC No.
          </label>
          <div className="field-container" id="RO_ThirdChildIdentification">
            {renderValue({
              fieldName: "ThirdChildIdentification",
              fieldFormat: "text",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="ThirdChildIdentification"
              name="ThirdChildIdentification"
            />
          </div>
        </div>
        <div style={{ width: 250 }}>
          <label htmlFor="ThirdChildBirthDate">Date of birth</label>
          <div className="field-container" id="RO_ThirdChildBirthDate">
            {renderValue({
              fieldName: "ThirdChildBirthDate",
              fieldFormat: "date",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="ThirdChildBirthDate"
              name="ThirdChildBirthDate"
            />
          </div>
        </div>
        <div style={{ width: 100 }}>
          <label htmlFor="ThirdChildGender">Sex</label>
          <div className="field-container" id="RO_ThirdChildGender">
            {renderValue({
              fieldName: "ThirdChildGender",
              fieldFormat: "text",
            })}
            <Field
              component={renderField}
              type="hidden"
              id="ThirdChildGender"
              name="ThirdChildGender"
            />
          </div>
        </div>
      </section>
    </fieldset>
    <fieldset>
      <table className="health-declaration">
        <thead className="header--black">
          <tr>
            <td rowSpan={2} />
            <td width="60%" rowSpan={2}>
              <h3>MEDICAL QUESTIONNAIRE (all 11 questions must be answered)</h3>
            </td>
            <td colSpan={2}>Employee</td>
            <td colSpan={2}>Spouse</td>
            <td colSpan={2}>Child</td>
            <td colSpan={2}>Child</td>
            <td colSpan={2}>Child</td>
          </tr>
          <tr>
            <td>Yes</td>
            <td>No</td>
            <td>Yes</td>
            <td>No</td>
            <td>Yes</td>
            <td>No</td>
            <td>Yes</td>
            <td>No</td>
            <td>Yes</td>
            <td>No</td>
          </tr>
        </thead>
        <tbody>
          <RadioButtonGroupRow
            questionDesc="Are you a member of any military force (excluding National Reservist), do you contemplate to engage, or the past 5 years, have you engaged in any private flying or hazardous sports or races or flying other than as a fare paying paying passenger on a regular sheduled airline?"
            questionNumber={1}
            questionId="Adventure"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="Do you drink wine,beer or spirit?If so, please state type, quantity and frequency"
            questionNumber={2}
            questionId="ConsumeAlcohol"
            questionInput={{ type: "text", name: "EmpAlcoholDetails" }}
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="Has any application for or reinstatement of life or accident insurance ever been declined, postponed, rated or in any way modified?"
            questionNumber={3}
            questionId="Exclusions"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="To the best of your knowledge and belief, has any of your immediate family ever had tuberculosis, diabetes, heart disease, mental disease or any AIDS related condition?"
            questionNumber={4}
            questionId="FamilyHistory"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="Have you EVER used any habit forming drugs or narcotics or alcohol excessively or treated for alcoholism or drug habits?"
            questionNumber={5}
            questionId="DrugAddiction"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <tr>
            <td>6</td>
            <td>In the past 12 months,</td>
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
          </tr>
          <RadioButtonGroupRow
            questionDesc="a) have you smoked cigarettes? If so, how many per day?"
            questionId="Smoke"
            questionInput={{ type: "text", name: "EmpSmokeQuantity" }}
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="b) did you previously smoke more than you do now?If so, how many did you smoke when you cut down, stop on whose advice?"
            questionId="SmokeLess"
            questionInput={{ type: "text", name: "EmpSmokeLessQuantity" }}
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="c) have you lost more than 3 kgs(6.6 lbs) of weight?If so, give the reason for the loss."
            questionId="WeightLoss"
            questionInput={{ type: "text", name: "EmpWeightLossReason" }}
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <tr>
            <td>7</td>
            <td>Have you EVER had or been told you had or been treated for:</td>
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
          </tr>
          <RadioButtonGroupRow
            questionDesc="a) asthma, tuberculosis, respiratory or lung disease?"
            questionId="LungDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="b) rheumatic fever, high blood pressure, stroke,chest pain, heart murmur, disease of the heart, blood or blood vessels?"
            questionId="HeartDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="c) peptic ulcer or bowel, liver or gall bladder disease?"
            questionId="GallbladderDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="d) renal stone, abnormal urinalysis or any disorder of the genito-urinary system?"
            questionId="KidneyDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="e) epilepsy, mental or nervous disorder?"
            questionId="MentalDisorders"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="f) diabetes, venereal disease, cancer, tumour or any other disease, disorder or severe injury?"
            questionId="BloodDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="g) hepatitis or found to be a carrier of hepatitis B?"
            questionId="HepatitisDisease"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="h) any form of eye, hearing or speech disorder or disease?"
            questionId="HearingAndSight"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="i) any disease or disorder of muscles, spine,brain, joints and limbs including loss of sensation, tremor or giddiness?"
            questionId="PhysicalInjury"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionNumber={8}
            questionDesc="Have you received any medical advice, counselling or treatment in connection with AIDS Related Complex
                   or any other AIDS related condition, or been told you had any of these or that you had a positive HIV blood test or in
                   the last 3 months had any of the following symptoms for more than 1 week continuously : fatigue, weght loss, diarrhoea,
                   enlarged lymph nodes or unusual skin lesions?"
            questionId="SexualDisease"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <tr>
            <td>9</td>
            <td>In the past 5 years, have you had any :</td>
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
          </tr>
          <RadioButtonGroupRow
            questionDesc="a) pre-employment/annual check-up, health screening? If so, please state the result, date done and name and address of
                   Clinic where tests are done in the space provide below."
            questionId="PreHealthScreening"
            questionInput={{
              type: "text",
              name: "EmpPreHealthScreeningDetails",
            }}
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="b) diagnostic tests such as X-ray, electrocardiogram or blood study?"
            questionId="DiagnosisInfo"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="c) double vision, coughing with blood, nose bleeds, tarry stools or bleeding from the rectum or urinary tract?"
            questionId="ExcretoryDisease"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="d) illness, operation, medical advice, hospital treatment not mentioned above?"
            questionId="OtherDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionNumber={10}
            questionDesc="Are you also insured or insured as a dependant under another Group policy with AIA? If yes, please furnish information of the other policy:"
            questionId="OtherGroupPolicy"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <tr>
            <td />
            <td>
              a) Group Policy holder name
              <Field
                component={renderField}
                type="text"
                id="OtherGroupPolicyName"
                name="OtherGroupPolicyName"
              />
              <br />b) Group Policy number
              <Field
                component={renderField}
                type="text"
                id="OtherGroupPolicyNumber"
                name="OtherGroupPolicyNumber"
              />
              <br />c) Name of Spouse (who is Employee under that Policy)
              <Field
                component={renderField}
                type="text"
                id="OtherGroupPolicySpouseName"
                name="OtherGroupPolicySpouseName"
              />
              <br />d) NRIC/PP no. of Spouse
              <Field
                component={renderField}
                type="text"
                id="OtherGroupPolicySpouseIdentification"
                name="OtherGroupPolicySpouseIdentification"
              />
            </td>
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
          </tr>
          <tr>
            <td>11</td>
            <td>Female only *</td>
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
          </tr>
          <RadioButtonGroupRow
            questionDesc="a) Have you ever been to any doctor for a Pap Smear (cervical smear)? If yes, please state result"
            questionId="PapSmear"
            questionInput={{ type: "text", name: "EmpPapSmearResult" }}
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="b) Have you at any time in the past been advised by any doctor to have a repeated Pap Smear within 6 months?"
            questionId="PapSmearDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="c) Have you ever consulted a doctor for irregular, painful menstruation or other problem(s) involving the female organs, or breasts?"
            questionId="MenstruationDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="d) Have you been to a doctor for a &quot;breast check-up&quot;, or been advised to have an X-ray (mammogram), biopsy, or operation of the breast?"
            questionId="Gynaecological"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="e) Have any of your family members (namely grandmother, aunt(s), mother, sister(s) been diagnosed to have breast cancer?If yes, please complete the following :"
            questionId="BreastCancer"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <tr>
            <td />
            <td className="subitem">
              <table
                className="border--default text--center"
                style={{ textIndent: 0 }}
              >
                <thead>
                  <tr>
                    <th width="30%" rowSpan={2}>
                      Relationship to Insured
                    </th>
                    <th width="25%" rowSpan={2}>
                      Age of Diagnosis
                    </th>
                    <th width="45%" colSpan={3}>
                      Breast involvement
                    </th>
                  </tr>
                  <tr>
                    <th>One</th>
                    <th>Both</th>
                    <th>Unknown</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <Field
                        component={renderField}
                        type="text"
                        id="EmpBreastCancerFamilyRelation1"
                        name="EmpBreastCancerFamilyRelation1"
                      />
                    </td>
                    <td>
                      <Field
                        component={renderField}
                        type="text"
                        id="EmpBreastCancerFamilyAgeDiagnosed1"
                        name="EmpBreastCancerFamilyAgeDiagnosed1"
                      />
                    </td>
                    <td>
                      <Field
                        component={renderField}
                        type="text"
                        id="EmpBreastCancerFamilyOne1"
                        name="EmpBreastCancerFamilyOne1"
                      />
                    </td>
                    <td>
                      <Field
                        component={renderField}
                        type="text"
                        id="EmpBreastCancerFamilyBoth1"
                        name="EmpBreastCancerFamilyBoth1"
                      />
                    </td>
                    <td>
                      <Field
                        component={renderField}
                        type="text"
                        id="EmpBreastCancerFamilyUnknown1"
                        name="EmpBreastCancerFamilyUnknown1"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Field
                        component={renderField}
                        type="text"
                        id="EmpBreastCancerFamilyRelation2"
                        name="EmpBreastCancerFamilyRelation2"
                      />
                    </td>
                    <td>
                      <Field
                        component={renderField}
                        type="text"
                        id="EmpBreastCancerFamilyAgeDiagnosed2"
                        name="EmpBreastCancerFamilyAgeDiagnosed2"
                      />
                    </td>
                    <td>
                      <Field
                        component={renderField}
                        id="EmpBreastCancerFamilyOne2"
                        name="EmpBreastCancerFamilyOne2"
                      />
                    </td>
                    <td>
                      <Field
                        component={renderField}
                        id="EmpBreastCancerFamilyBoth2"
                        name="EmpBreastCancerFamilyBoth2"
                      />
                    </td>
                    <td>
                      <Field
                        component={renderField}
                        id="EmpBreastCancerFamilyUnknown2"
                        name="EmpBreastCancerFamilyUnknown2"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Field
                        component={renderField}
                        type="text"
                        id="EmpBreastCancerFamilyRelation3"
                        name="EmpBreastCancerFamilyRelation3"
                      />
                    </td>
                    <td>
                      <Field
                        component={renderField}
                        type="text"
                        id="EmpBreastCancerFamilyAgeDiagnosed3"
                        name="EmpBreastCancerFamilyAgeDiagnosed3"
                      />
                    </td>
                    <td>
                      <Field
                        component={renderField}
                        id="EmpBreastCancerFamilyOne3"
                        name="EmpBreastCancerFamilyOne3"
                      />
                    </td>
                    <td>
                      <Field
                        component={renderField}
                        id="EmpBreastCancerFamilyBoth3"
                        name="EmpBreastCancerFamilyBoth3"
                      />
                    </td>
                    <td>
                      <Field
                        component={renderField}
                        id="EmpBreastCancerFamilyUnknown3"
                        name="EmpBreastCancerFamilyUnknown3"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
          </tr>
          <RadioButtonGroupRow
            questionDesc="f) Are you currently pregnant? If so, how many months?"
            questionId="Pregnant"
            questionInput={{
              type: "text",
              name: "EmpPregnantDurationValue",
            }}
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="g) Have you ever been pregnant? At what age was your 1st pregnancy?"
            questionId="HaveBeenPregnant"
            questionInput={{ type: "text", name: "EmpHaveBeenPregnantAge" }}
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
        </tbody>
      </table>
    </fieldset>
    <fieldset>
      <strong>
        If any of the above answers is "Yes", please give full details in the
        space provided below
      </strong>
      <table>
        <tbody>
          <tr>
            <td width="10%" className="text--center">
              Qn No.
            </td>
            <td width="25%" className="text--center">
              Name of Insured
            </td>
            <td width="65%" className="text--center">
              Please provide details of diagnosis/condition, result, date of
              consultation, name and address of doctor seen
            </td>
          </tr>
          <MoreInfoGroupRow number={1} />
          <MoreInfoGroupRow number={2} />
          <MoreInfoGroupRow number={3} />
          <MoreInfoGroupRow number={4} />
          <MoreInfoGroupRow number={5} />
          <MoreInfoGroupRow number={6} />
          <MoreInfoGroupRow number={7} />
        </tbody>
      </table>
    </fieldset>
    <div className="declaration">
      <h3>Declarations</h3>
      <p>
        1) I hereby declare and confirm that I have read and understood the
        contents of "Your Guide to Health Insurance" and "Product Summary".
        (Applicable if coverage is on voluntary basis).
      </p>
      <p>2) I/We hereby authorise, agree and consent to:</p>
      <p>
        (a) persons and organisations, whether within or outside Singapore,
        including but not limited to medical sources, hospitals, doctors, other
        healthcare professionals, laboratories, regulator, dispute resolution
        centres and insurers, their associated persons/organisations, my/our or
        the insured person’s employers or financial service providers, or their
        third party service providers or representatives (collectively “
        <strong>Third Parties</strong>
        ”) disclosing and releasing to AIA Singapore Private Limited ("
        <strong>AIA Singapore</strong>
        "), its associated persons/organisations, its and their third party
        service providers and its and their representatives, whether within or
        outside Singapore (collectively “
        <strong>AIA Persons</strong>
        ”), any information concerning the policy owner and the insured
        person(s) at any time, including all personal data and information,
        medical information, medical history, consultation history and notes,
        prescriptions, treatments, descriptions of medical services rendered,
        and any employment and financial information, including the taking of
        copies of such records (collectively “
        <strong>Personal Data</strong>
        ”), relevant for the Purpose (defined below);
      </p>
      <p>
        (b) the AIA Persons sharing the scope of sub-clause (a) above, along
        with any of the Personal Data, with any relevant Third Parties to
        procure their disclosure and release of additional relevant Personal
        Data for the Purpose;
      </p>
      <p>
        (c) the AIA Persons, including their approved medical examiners or
        laboratories, performing any necessary medical assessments and
        examinations and tests to determine, assess and evaluate the health of
        the insured person(s);
      </p>
      <p>
        (d) the AIA Persons collecting, using, disclosing, storing, retaining
        and/or processing (collectively, “
        <strong>Using”/“Use</strong>
        ”) the Personal Data for the Purpose; and
      </p>
      <p>
        (e) waive any right (on my own behalf and on behalf of the insured
        person(s) where applicable, in respect of which I/we represent and
        warrant that the insured person(s) have granted me/us authority to so
        waive) to bring a claim of any nature against any of the AIA Persons in
        respect of any above-mentioned Use and/or any Use of any Personal Data
        for the Purpose.
      </p>
      <p>
        Where I/we are not the insured person, I/we represent and warrant that
        I/we have obtained the consent of the insured person(s), except to the
        extent such consent is not required under relevant laws: (i) to collect
        their Personal Data; (ii) to disclose their Personal Data to the AIA
        Persons; and (iii) for the AIA Persons and Third Parties to Use any of
        their Personal Data in the manner and for the purposes described in this
        Clause. I/We hereby agree to indemnify AIA Persons for all losses and
        damages that AIA Persons may suffer in the event that I/we are in breach
        of any representation and warranty provided by me/us herein. In this
        Clause, “
        <strong>Purpose</strong>
        ” means any of the purposes described in the AIA Personal Data Policy,
        including but not limited to processing of this form, to provide
        subsequent advice or services to me/us or the insured person in relation
        to any existing or future policy/policies/programmes that I/we may
        hold/participate with AIA Singapore. This authorisation shall bind
        my/our successors and assignees, and remains valid, notwithstanding
        death, irrespective of whether or not my/our Application/form is
        accepted by AIA Singapore. A photocopy of this authorisation shall be
        valid and effective as the original.
      </p>
      <p>
        3) I understand and agree that AIA Singapore is entitled not to accept
        or process this form should I or any of my dependents be found to be a
        Prohibited Person, meaning a person/entity subject to any laws,
        regulations and/or sanctions administered by any regulatory authorities
        in any country , which have the effect of prohibiting AIA Singapore from
        providing insurance coverage, transacting business with or otherwise
        offering any economic benefits to me/my dependents or any other
        beneficiary under the Policy , and the decision of AIA Singapore shall
        be final. I/We further agree that in the event that AIA becomes aware
        subsequently that the Policyholder/myself/any of my dependents has
        become a Prohibited Person , AIA Singapore may block and/or terminate
        the Policy with immediate effect, remove myself or my dependents from
        coverage under the Policy and shall not thereafter be required to
        transact any business with the Policyholder and/or myself/my dependents
        in connection with the Policy, including but not limited to, making or
        receiving any payments under the Policy.
      </p>
      <p>
        4) I/We further agree that this form may be signed and delivered by
        facsimile, electronic mail or other electronic means, including via a
        website or electronic portal designated by AIA Singapore. A copy of such
        form received via any of the above means may be stored electronically or
        using other means by or under the authority of AIA Singapore and such
        copy shall have the same legal effect and validity as if it were the
        original.
      </p>
      <br />
      <p>
        {
          <CheckboxField
            validate={validateRequired}
            name="declaration"
            id="declaration"
          >
            <strong>I have read and accept this declaration</strong>
          </CheckboxField>
        }
      </p>
    </div>
    <table className="signature border--none">
      <tbody>
        <tr>
          <td className="text--left" style={{ width: 140 }}>
            Dated at Singapore this
          </td>
          <td />
          <td />
          <td />
          <td />
        </tr>
        <tr>
          <td />
          <td className="line" style={{ width: 140 }}>
            (mm dd yy)
          </td>
          <td className="line">Employee's name</td>
          <td className="line">
            Employee's signature
            <br />(for self & dependants)
          </td>
          <td className="line">
            Company's Stamp & signature
            <br />of Employer (witness)
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aia/AIAHD201611.js